import { ProviderProfile, UUID } from "@/core/types";
import { providerRequestsTyped } from "@/api/(requests)/providerTyped";

export async function getProviderProfile(providerId?: UUID): Promise<ProviderProfile> {
  const { user } = await providerRequestsTyped.fetch_provider_profile({
    searchParams: { provider_id: providerId },
  });

  return user;
}
